import { IModelDataV1, Model } from '@df/catalog/model';

export enum QuestionType {
    Boolean = 'boolean',
    Text = 'text',
    TextArea = 'boolean_with_textarea'
}

export interface IQuestionData extends IModelDataV1 {
    created_at: string;
    question: string;
    question_type: 'boolean' | 'text' | 'boolean_with_textarea';
    required: 1 | 0;
    sort_order: number;
    verbosity: 1;
    type: 'question';
}

export class Question extends Model<IQuestionData, number> {
    static override type = 'question';

    /**
     * Returns question type
     * @returns {string | undefined}
     */
    get questionType(): string | undefined {
        return this.data && this.data.question_type;
    }

    /**
     * Is boolean question type getter
     * @returns {boolean}
     */
    get isBoolean(): boolean {
        return this.questionType === QuestionType.Boolean;
    }
    /**
     * Is text question type getter
     * @returns {boolean}
     */
    get isText(): boolean {
        return this.questionType === QuestionType.Text;
    }
    /**
     * Is boolean with textarea question type getter
     * @returns {boolean}
     */
    get isTextarea(): boolean {
        return this.questionType === QuestionType.TextArea;
    }
}
